'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface Genre {
  id: string;
  name: string;
  count: number;
}

const genres: Genre[] = [
  { id: 'all', name: 'All Books', count: 247 },
  { id: 'fiction', name: 'Fiction', count: 52 },
  { id: 'mystery', name: 'Mystery', count: 38 },
  { id: 'fantasy', name: 'Fantasy', count: 44 },
  { id: 'scifi', name: 'Science Fiction', count: 31 },
  { id: 'romance', name: 'Romance', count: 27 },
  { id: 'thriller', name: 'Thriller', count: 23 },
  { id: 'historical', name: 'Historical', count: 19 },
  { id: 'nonfiction', name: 'Non-Fiction', count: 13 },
  { id: 'biography', name: 'Biography', count: 8 },
  { id: 'selfhelp', name: 'Self-Help', count: 6 },
  { id: 'poetry', name: 'Poetry', count: 4 },
  { id: 'horror', name: 'Horror', count: 12 },
  { id: 'classics', name: 'Classics', count: 15 },
  { id: 'youngadult', name: 'Young Adult', count: 18 },
];

interface GenreFilterProps {
  selectedGenre: string;
  onGenreChange: (genre: string) => void;
}

export default function GenreFilter({ selectedGenre, onGenreChange }: GenreFilterProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      {/* Mobile Dropdown */}
      <div className="lg:hidden mb-6">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center justify-between px-6 py-4 rounded-xl border border-border bg-card hover:bg-card/80 transition-colors"
        >
          <span className="text-sm font-medium text-foreground">
            {genres.find(g => g.id === selectedGenre)?.name} ({genres.find(g => g.id === selectedGenre)?.count})
          </span>
          <Icon name={isOpen ? 'ChevronUpIcon' : 'ChevronDownIcon'} size={20} className="text-muted-foreground" />
        </button>

        {isOpen && (
          <div className="absolute top-full left-0 right-0 mt-2 p-2 rounded-xl border border-border bg-card backdrop-blur-xl z-10 max-h-96 overflow-y-auto">
            {genres.map((genre) => (
              <button
                key={genre.id}
                onClick={() => {
                  onGenreChange(genre.id);
                  setIsOpen(false);
                }}
                className={`w-full text-left px-4 py-3 rounded-lg transition-colors ${
                  selectedGenre === genre.id
                    ? 'bg-primary/10 text-primary' :'text-foreground hover:bg-muted'
                }`}
              >
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">{genre.name}</span>
                  <span className="text-xs text-muted-foreground">{genre.count}</span>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Desktop Chips */}
      <div className="hidden lg:flex flex-wrap gap-3">
        {genres.map((genre) => (
          <button
            key={genre.id}
            onClick={() => onGenreChange(genre.id)}
            className={`px-5 py-2.5 rounded-full border text-sm font-medium transition-all ${
              selectedGenre === genre.id
                ? 'border-primary bg-primary/10 text-primary' :'border-border bg-card text-foreground hover:border-primary/30 hover:bg-card/80'
            }`}
          >
            {genre.name} <span className="text-muted-foreground ml-1">({genre.count})</span>
          </button>
        ))}
      </div>
    </div>
  );
}